var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"appup-avatar",attrs:{"id":_vm.id,"src":_vm.src,"rounded":"circle","width":_vm.imageSize,"height":_vm.imageSize}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/avatar/avatar.vue